export const SET_HOME_DOCUMENTS = "SET_HOME_DOCUMENTS";
export const RESET_INITIAL_HOME_STATE = "RESET_INITIAL_HOME_STATE";
export const SET_WITNESS_OBJ = "SET_WITNESS_OBJ";

export const setWitnessObj = (obj) => {
  return (dispatch) => {
    dispatch({ type: SET_WITNESS_OBJ, obj });
  };
};
export const setHomeDocuments = (documents) => {
  return (dispatch) => {
    dispatch({ type: SET_HOME_DOCUMENTS, documents });
  };
};
export const resetInitialHomeState = () => {
  return (dispatch) => {
    dispatch({ type: RESET_INITIAL_HOME_STATE });
  };
};
